'use client';
import { EXPOSURE_RECORD, sendClickTrack } from '@/tracks/31846';
// -------------- styles -------------------- //
import styles from './BestSellerSubSidebar.module.scss';
import { returnCurrentRankPage } from '../../utils';

interface BestSellerSubSidebarPropType {
  sidebarData: any;
  bestSellerProductData: any;
  sidebarResMain: any;
  sequenceId: string;
  parentSequenceId: string;
  parentcategoryName: string;
  setSequenceId: (index: string) => void;
  handleFetch: (val: string) => void;
  handleFetchRecommendData: (val: string) => void;
}

const BestSellerSubSidebar = ({
  sidebarData,
  sidebarResMain,
  bestSellerProductData,
  sequenceId,
  parentSequenceId,
  parentcategoryName,
  setSequenceId,
  handleFetch,
  handleFetchRecommendData,
}: BestSellerSubSidebarPropType) => {
  const handleSelect = (sequenceId: string) => {
    // handle bold
    setSequenceId(sequenceId);
    // handle main container data
    handleFetch(sequenceId);
    // handle recommend data
    handleFetchRecommendData(sequenceId);
  };

  const tabArray = sidebarData?.map((tab: any) => tab?.categoryTabName) || [];
  const trackArray = [bestSellerProductData?.data?.categoryTabName, ...tabArray];

  const currentBestSellerLevel = bestSellerProductData?.data?.level;

  // -------------- 根据榜单级别下发展示  -------------------- //
  const parentSequenceIdString =
    currentBestSellerLevel === 2
      ? bestSellerProductData?.data?.sequenceId
      : bestSellerProductData?.data?.parentSequenceId;
  const parentSequenceIdName =
    currentBestSellerLevel === 2
      ? bestSellerProductData?.data?.categoryTabName
      : bestSellerProductData?.data?.parentSequenceCategoryTabName;

  return (
    <div
      className={styles.container}
      exptag={'exp|' + EXPOSURE_RECORD.Activity_RankDetail_Tab_Expo}
      data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
      data-exptag-json-param={JSON.stringify({
        tabName: trackArray || '-100',
      })}
    >
      <a
        href='/promo/best-seller'
        className={styles.higherCategoryTag}
        onClick={() =>
          sendClickTrack.Activity_RankDetail_Tab_Back({
            tab_name: 'ALL',
            cateLevel: 0,
            index: 0,
          })
        }
      >
        {`< ${sidebarResMain && sidebarResMain[0]?.categoryTabName}`}
      </a>

      <a
        href={`/promo/best-seller?tag=${parentSequenceId}`}
        className={styles.higherCategoryTag}
        onClick={() =>
          sendClickTrack.Activity_RankDetail_Tab_Back({
            tab_name: bestSellerProductData?.data?.parentSequenceCategoryTabName || '-100',
            cateLevel: 2,
            index: 1,
          })
        }
      >
        {`< ${parentcategoryName}`}
      </a>
      <div className={styles.lowerCategoryContainer}>
        <button
          onClick={() => handleSelect(parentSequenceIdString)}
          className={`${sequenceId === parentSequenceIdString ? styles.titleBold : styles.titleNormal}`}
        >
          {parentSequenceIdName}
        </button>
      </div>
      {sidebarData &&
        sidebarData.map((items: any, index: number) => {
          return (
            <div key={index} className={styles.lowerCategoryContainer}>
              <button
                key={items.name + index}
                onClick={() => {
                  handleSelect(items?.sequenceId);
                  // change url text
                  window.history.pushState(
                    {},
                    '',
                    returnCurrentRankPage(items?.sequenceId, items?.categoryTabName),
                  );
                  sendClickTrack.Activity_RankDetail_Tab({
                    tabName: items?.categoryTabName || '-100',
                    cateLevel: items?.level || '-100',
                    index: index || -100,
                  });
                }}
                className={`${styles.lower} ${sequenceId === items?.sequenceId ? styles.titleBold : styles.titleNormal}`}
              >{`${items?.categoryTabName}`}</button>
            </div>
          );
        })}
    </div>
  );
};

export default BestSellerSubSidebar;
